import type { VariantProps } from '@config/tailwind/cva'
import { cva } from '@config/tailwind/cva'

const typographyVariants = cva("ui:[font-family:'Poppins',sans-serif]", {
  variants: {
    variant: {
      // Display
      display: 'ui:text-[40px] ui:font-extrabold ui:leading-[56px] ui:tracking-normal',
      // Headlines
      'headline-lg': 'ui:text-[28px] ui:font-bold ui:leading-[40px] ui:tracking-normal',
      'headline-md': 'ui:text-[24px] ui:font-bold ui:leading-[36px] ui:tracking-normal',
      'headline-sm': 'ui:text-[20px] ui:font-bold ui:leading-[28px] ui:tracking-[0.5px]',
      // Titles
      'title-lg': 'ui:text-[18px] ui:font-semibold ui:leading-[24px] ui:tracking-[0.2px]',
      'title-md': 'ui:text-[16px] ui:font-semibold ui:leading-[24px] ui:tracking-[0.2px]',
      'title-sm': 'ui:text-[14px] ui:font-semibold ui:leading-[20px] ui:tracking-[0.5px]',
      // Labels
      'label-lg': 'ui:text-[16px] ui:font-medium ui:leading-[24px] ui:tracking-[0.15px]',
      'label-md': 'ui:text-[14px] ui:font-medium ui:leading-[20px] ui:tracking-[0.5px]',
      'label-sm': 'ui:text-[12px] ui:font-medium ui:leading-[16px] ui:tracking-[0.5px]',
      // Body
      'body-lg': 'ui:text-[16px] ui:font-normal ui:leading-[20px] ui:tracking-[0.5px]',
      'body-md': 'ui:text-[14px] ui:font-normal ui:leading-[20px] ui:tracking-[0.25px]',
      'body-sm': 'ui:text-[12px] ui:font-normal ui:leading-[16px] ui:tracking-[0.5px]',
    },
  },
  defaultVariants: {
    variant: 'body-md',
  },
})

type TypographyVariant = VariantProps<typeof typographyVariants>['variant']

export { typographyVariants, type TypographyVariant }
